import { CurrentUserData } from "lib/hooks/api/users/useCurrentUser";

/**
 * Single source of truth for "this self-serve user still needs to complete onboarding".
 * a self-serve user who has neither signal settings nor a team default search topic must be
 * forced into the onboarding flow. Used by the root router guard (force users in) and by the
 * onboarding route guard (let already-configured users out) so the two stay exact inverses.
 * @param user
 * @returns
 */
export function needsSelfServeOnboarding(user: CurrentUserData | undefined | null): boolean {
  if (!user) return false;
  const hasSignalSettings =
    user.team.signalSettings != null && user.team.signalSettings != undefined;
  const hasDefaultSearchTopic =
    user.team.metadata.defaultSearchTopic != null &&
    user.team.metadata.defaultSearchTopic != undefined;
  return user.company.selfServe && !hasSignalSettings && !hasDefaultSearchTopic;
}
